// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"361":"b73fc6af09eb259b8737","3093":"33b2b77f21490c6cfefb","3180":"e0290e9931ace4cc34de"}[chunkId] + ".css";
};